<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fFN284/images/9781250062130.jpg?1717849532005" alt="This image is the cover for the book Horse Called Hero"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Horse Called Hero
      </h1>
      <p class="bookDescription body article font2">
        <p>In <i>A Horse Called Hero </i>by Sam Angus, it is the brink of World War II, and a family forced out of their London home flees to the country. Wolfie and his older sister Dodo are devastated to leave behind everything they've ever known, but they begin settling into their new life.<br/><br/>One day, they come across an orphaned fowl, which they raise as Hero, a strong and beautiful horse who lives up to his name when he saves the children from a fire.<br/><br/>Wolfie and Dodo find comfort in their new life, but the war is escalating quickly and horses are needed for combat. One night, Hero is stolen, and the children are shattered. Years then pass without any indication Hero will return. It's only when Wolfie becomes a stable hand that he discovers Hero has ended up working in the mines under terrible conditions. Then and there, Wolfie resolves to save Hero, a plan that places both of their lives in jeopardy. Together again, can they will survive?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sam Angus
      </h2>
      
      <p class="authorDescription body article"><B>Sam Angus</B> grew up in Spain. She studied literature at Trinity College in Cambridge, and taught English before becoming a ski wear designer. She's the author of <I>Soldier</I><I>Dog</I> and divides her time between London and Exmoor with her children, horses, and dogs.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Feiwel and Friends
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f9441cc